module.exports = __webpack_public_path__ + "static/media/taping.1190f608.mp4";